import type { ApiSchemas } from '@rental/contracts/client'
import type { SecondDriverHandover } from '@rental/domain'

type Sheet = ApiSchemas['CheckoutSheet']

/**
 * Q-162: what the hand-over knows of the booking's live second driver, from
 * the sheet the server judged. The same facts the server passes to
 * `checkoutBlocks`, so the counter sees its blocks before pressing.
 */
export function secondDriverFacts(sheet: Sheet): SecondDriverHandover | null {
  const second = sheet.secondIdentity
  if (!second) return null
  const latest = second.latest
  return {
    identityRecorded: latest !== null,
    eligibilityStatus: second.eligibilityStatus,
    overridden: second.overridden,
    birthDateDiffers:
      latest !== null &&
      second.bookingBirthDate !== null &&
      second.bookingBirthDate !== latest.birthDate,
  }
}

/** The second driver's recorded identity, for the CaRGOS report that must cover it. */
export function secondIdentityId(sheet: Sheet): string | null {
  return sheet.secondIdentity?.latest?.id ?? null
}
